import { useEffect, useRef, useState } from "react";
import { BaseDto, EditableReportQuestion } from "../../../types/Rows";
import { useTemplateContext } from "../templateContext";
import { Question } from "./Question";

export const Row = ({
  templateId,
  input,
  index,
  sectionId,
  isLocked,
  depth,
}: {
  templateId: string;
  index: number;
  input: EditableReportQuestion;
  sectionId: string;
  isLocked: boolean;
  depth: number;
}) => {
  // load previous answers for a given row
  const { updateQuestion } = useTemplateContext();

  const [description, setDescription] = useState<string>(input?.description);
  const [isBlank, setIsBlank] = useState<boolean>(input.isBlank);
  const [isDirectAnswer, setIsDirectAnswer] = useState<boolean>(input.isDirectAnswer);
  const [childrenRequiredAnswer, setChildrenRequiredAnswer] = useState(
    input.requiredAnswerToBeVisible
  );

  // Do zapisu trafia tylko pytanie zmienione przez użytkownika (nie każde wyświetlone)
  const firstRun = useRef(true);
  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    updateQuestion({
      ...input,
      description: description,
      isBlank: isBlank,
      isDirectAnswer: isDirectAnswer,
      requiredAnswerToBeVisible: childrenRequiredAnswer,
    } as EditableReportQuestion);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description, isBlank, isDirectAnswer, childrenRequiredAnswer]);

  return (
    <Question
      index={index + 1}
      input={input}
      childrenRequiredAnswer={childrenRequiredAnswer}
      setChildrenRequiredAnswer={setChildrenRequiredAnswer}
      description={description}
      setDescription={setDescription}
      templateId={templateId}
      isBlank={isBlank}
      setIsBlank={setIsBlank}
      isDirectAnswer={isDirectAnswer}
      setIsDirectAnswer={setIsDirectAnswer}
      sectionId={sectionId}
      isLocked={isLocked}
      depth={depth}
    />
  );
};
